import React, { useEffect, useState } from "react";

export default function Countdown({ targetIso }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const target = targetIso ? new Date(targetIso).getTime() : 0;
  const diff = Math.max(0, target - now);
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  const cell = (v, l) => (
    <div className="flex flex-col items-center min-w-[64px]">
      <span className="font-display text-4xl text-[#FF3B30]">{String(v).padStart(2, "0")}</span>
      <span className="text-[10px] font-mono tracking-widest text-black/50">{l}</span>
    </div>
  );
  return (
    <div className="flex gap-3" data-testid="countdown">
      {cell(d, "DAYS")}<span className="font-display text-3xl text-black/30">:</span>
      {cell(h, "HRS")}<span className="font-display text-3xl text-black/30">:</span>
      {cell(m, "MIN")}<span className="font-display text-3xl text-black/30">:</span>
      {cell(s, "SEC")}
    </div>
  );
}
